<template>
    <div>
        <b-navbar toggleable="lg" class="">
            <b-navbar-brand class="margin-left pointer" @click="navigateTo('/')">
                <img src="@/assets/icons/dollar-info-icon.png" width="20%" >
                <span class="text-color-white margin-left">Dólar Info</span>
            </b-navbar-brand>

            <b-navbar-toggle class="margin-right" target="nav-collapse">
                <template #default="{ expanded }">
                    <b-icon class="text-color-white" v-if="expanded" icon="chevron-bar-up"></b-icon>
                    <b-icon class="text-color-white" v-else icon="chevron-bar-down"></b-icon>
                </template>
            </b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav class="justify-content-center">
                <b-navbar-nav class="">
                    <b-nav-item class="navbar-item" @click="navigateTo('/')">
                        <span class="text-color-white margin-left">
                            Panel principal
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" @click="navigateTo('/Indexes')">
                        <span class="text-color-white margin-left">
                            Índices
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" @click="navigateTo('/FixedTerm')">
                        <span class="text-color-white margin-left">
                            Plazos fijos
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" @click="navigateTo('/History')">
                        <span class="text-color-white margin-left">
                            Histórico
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" @click="navigateTo('/Currencies')">
                        <span class="text-color-white margin-left">
                            Otras monedas
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" @click="navigateTo('/Donations')">
                        <span class="text-color-white margin-left">
                            Donaciones
                        </span>
                    </b-nav-item>

                    <b-nav-item class="navbar-item" href="/" v-if="screenWidth > 768"></b-nav-item>

                    <!-- Right section -->
                    <div class="navbar-end">
                        <b-dropdown
                            class="navbar-dropdown"
                            :class="[screenWidth < 768 ? 'margin-left-double' : '']" 
                            variant="outline-dark" right>
                            <template #button-content>
                                <span class="icon text-color-white">
                                    <b-icon-people />
                                </span>
                            </template>
                            <b-dropdown-item class="navbar-dropdown-item" v-if="!userData" @click="goToLogin()">
                                Iniciar sesión
                            </b-dropdown-item>
                            <b-dropdown-item class="navbar-dropdown-item" v-if="!userData" @click="goToRegister()">
                                Registrar
                            </b-dropdown-item>
                            <b-dropdown-item class="navbar-dropdown-item" v-if="userData" @click="goToMyProfile()">
                                Ver mi perfil
                            </b-dropdown-item>
                            <b-dropdown-divider v-if="userData"></b-dropdown-divider>
                            <b-dropdown-item class="navbar-dropdown-item" v-if="userData" @click="logout()">
                                Cerrar sesión
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-navbar-nav>
            </b-collapse>

            <!-- <span v-if="userData">
                {{ userData.data?.fullName }}
            </span> -->
            <!-- <ThemeSwitch @theme-change="$emit('theme-change', $event)"/> -->
        </b-navbar>
    </div>
</template>

<script>
import "@/assets/style.css"
import { mapGetters, mapActions } from "vuex"
import ThemeSwitch from '@/components/Navbar/ThemeSwitch.vue';

export default {
    name: "Navbar",
    components: { ThemeSwitch },

    data() {
        return { 
            screenWidth: window.innerWidth,
        }
    },

    async created() {
        const tokenJWT = localStorage.getItem('tokenJWT');

        if (tokenJWT) {
            await this.$store.dispatch('getUserData', tokenJWT);
        }

        this.updateScreenWidth();
        window.addEventListener('resize', this.updateScreenWidth);
    },

    destroyed() {
        window.removeEventListener('resize', this.updateScreenWidth);
    },

    methods: {
        updateScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
        
        async goToLogin() {
            if (window.location.pathname !== "/Login") {
                window.location.href = "/Login";
            }
        },

        async goToRegister() {
            if (window.location.pathname !== "/Register") {
                window.location.href = "/Register";
            }
        },

        async goToMyProfile() {
            if (window.location.pathname !== "/MyProfile") {
                window.location.href = "/MyProfile";
            }
        },

        async logout() {
            await this.$store.dispatch('logOut');
            window.location.href = "/";
        },

        navigateTo(path) {
            if (window.location.pathname !== path) {
                window.location.href = path;
            }
        },

        updateIsCollapsed(value) {
            this.isCollapsed = value;
        },

        updateProducts(index) {
            this.products = this.products.filter(i => i.index !== index);
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        }
    },
    
    watch: {
        // async orderId(newOrderId) {
        //     console.log("llego a orderId");
        //     await this.getOrder();
        // },
    },

    computed: { 
        ...mapGetters(['getUserData']),

        userData() {
            return this.getUserData;
        }
    }
}
</script>